export default __webpack_public_path__ + "static/media/medical_12.32740955.jpg";